import {
  FILAVIRTUAL,
  FILAVIRTUAL_FAIL,
  FILAVIRTUAL_RESET,
  FILAVIRTUAL_SUCCESS,
} from "../ActionTypes";
import filaVirtualInitialState from "../initialState/filaVirtualInitialState";

const filaVirtual = (state, { payload, type }) => {
  switch (type) {
    case FILAVIRTUAL:
      return {
        ...state,
        filaVirtual: {
          ...state.filaVirtual,
          loading: true,
          error: false,
          estado: null,
        },
      };
    case FILAVIRTUAL_SUCCESS:
      return {
        ...state,
        filaVirtual: {
          ...state.filaVirtual,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case FILAVIRTUAL_FAIL:
      return {
        ...state,
        filaVirtual: {
          ...state.filaVirtual,
          loading: false,
          error: payload,
          data: null,
        },
      };
    case FILAVIRTUAL_RESET:
      return filaVirtualInitialState;

    default:
      return state;
  }
};

export default filaVirtual;
